import React, { Component } from 'react';

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ItemOrderUpdateModal from '../../../../components/ItemOrderUpdateModal/ItemOrderUpdateModal'
import ShowItemBtn from '../../../../components/ShowItemBtn/ShowItemBtn';

class Rubros extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Codigo",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Pertenece a Grupo",
                    id: "GrupoPertenece",
                    accessor: d => d.GrupoPertenece,
                    show: true,
                },
                {
                    Header: "Rubro es Visible",
                    id: "Show",
                    accessor: d => d.Show ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 150,
                    className: "text-center",
                },
                {
                    Header: "Grupo es Visible",
                    id: "GrupoShow",
                    accessor: d => d.GrupoShow ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 150,
                    className: "text-center",
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 100,
                    className: "text-center",
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        const propsShowItemBtn = {
            label: 'Grupo',
            labelMany: 'Grupos',
            submitUrl: api.gestion.articulos.rubrosMostrarOcultar
        }
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="MOSTRAR" />),
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="OCULTAR" />),
                    },
                    {
                        detail: true,
                        component: () => <ItemOrderUpdateModal {...{
                            url: api.gestion.articulos.rubros,
                            type: "Rubros",
                            nameField: "Nombre",
                            pkField: "Codigo",
                            orderField: "Order"
                        }} />,
                        permission: "ecommerce_articulos_articulos_edit",
                    },
                ]}
                outerFilter={[{ id: "DeBaja", lookup: "exact", value: "False" }]}
                apiUrl={api.gestion.articulos.rubros}
                columns={this.state.columns}
                title={"Rubros"}
                multiSelect={true}
                ctrlKeyMultiSelect={true}
            />
        );
    }
}

export default Rubros;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Rubros/Rubros.js